<script>
  import { Checkbox, GridCell, GridRow, TruncatedText } from '@sveltia/ui';

  import AssetPreview from '$lib/components/assets/shared/asset-preview.svelte';
  import { goto } from '$lib/services/app/navigation';
  import { focusedAsset, selectedAssetPathSet, selectedAssets } from '$lib/services/assets';
  import { canPreviewAsset } from '$lib/services/assets/kinds';
  import { listedAssetIndexMap } from '$lib/services/assets/view';
  import { env } from '$lib/services/user/env.svelte';

  /**
   * @import { Asset, ViewType } from '$lib/types/private';
   */

  /**
   * @typedef {object} Props
   * @property {Asset} asset Asset.
   * @property {ViewType} viewType View type.
   */

  /** @type {Props} */
  let {
    /* eslint-disable prefer-const */
    asset,
    viewType,
    /* eslint-enable prefer-const */
  } = $props();

  const { name, kind } = $derived(asset);

  /**
   * Update the asset selection.
   * @param {boolean} selected Whether the current asset item is selected.
   */
  const updateSelection = (selected) => {
    const assets = selectedAssets.current;
    const index = assets.indexOf(asset);

    if (selected && index === -1) {
      selectedAssets.current = [...assets, asset];
    }

    if (!selected && index > -1) {
      selectedAssets.current = assets.filter((a) => a !== asset);
    }
  };
</script>

<!-- @todo Add support for drag to move. -->

<GridRow
  aria-rowindex={listedAssetIndexMap.current.get(asset.path) ?? -1}
  aria-label={name}
  onChange={(event) => {
    updateSelection(event.detail.selected);
  }}
  onfocus={() => {
    focusedAsset.current = asset;
  }}
  onclick={() => {
    if (
      (env.isSmallScreen || env.isMediumScreen) &&
      focusedAsset.current &&
      canPreviewAsset(focusedAsset.current)
    ) {
      goto(`/assets/${focusedAsset.current.path}`, { transitionType: 'forwards' });
    }
  }}
  ondblclick={() => {
    if (focusedAsset.current && canPreviewAsset(focusedAsset.current)) {
      goto(`/assets/${focusedAsset.current.path}`, { transitionType: 'forwards' });
    }
  }}
>
  {#if !(env.isSmallScreen || env.isMediumScreen)}
    <GridCell class="checkbox">
      <Checkbox
        role="none"
        tabindex="-1"
        checked={selectedAssetPathSet.current.has(asset.path)}
        onChange={({ detail: { checked } }) => {
          updateSelection(checked);
        }}
      />
    </GridCell>
  {/if}
  <GridCell class="image">
    <AssetPreview
      {kind}
      {asset}
      variant={viewType === 'list' ? 'icon' : 'tile'}
      cover={env.isSmallScreen}
      checkerboard={kind === 'image'}
    />
  </GridCell>
  {#if !env.isSmallScreen || viewType === 'list'}
    <GridCell class="title">
      <div role="none" class="label">
        <TruncatedText lines={2}>
          <bdi>{name}</bdi>
        </TruncatedText>
      </div>
    </GridCell>
  {/if}
</GridRow>

<style>
  .label {
    word-break: break-all;
  }
</style>
